import React, { useState } from 'react';
import ContentHeader from 'containers/Dashboard/ContentHeader';
import OperatorFilter from 'components/Dashboard/OperatorAgents/OperatorFilter';
import OperatorTable from 'components/Dashboard/OperatorAgents/OperatorTable';
import Loading from 'components/Basic/Loading';
import { useAppDispatch, useAppSelector } from 'utilities/redux';
import { useLazyGetOperatorListQuery } from 'core/operator/OperatorService';
import { setOperatorData } from 'core/operator/OperatorSlice';

const OperatorAgentList = () => {
  const dispatch = useAppDispatch();

  const [state, setState] = useState({
    searchText: '',
    offset: 0,
    limit: 10,
    filterQuery: '',
    stateFilter: '',
    searchFilterQuery: '',
    sort: '',
    isLoading: false,
  });

  const { list } = useAppSelector(state => state.operatorReducer);

  const [getOperatorList] = useLazyGetOperatorListQuery();

  const handleChangePage = async (offset, limit, filterQuery, sort) => {
    setState(prev => ({ ...prev, offset: offset, limit: limit, isLoading: true }));
    try {
      const res = await getOperatorList({
        offset,
        limit,
        or: false,
        filter: filterQuery || state.filterQuery + state.searchFilterQuery,
        sort: sort || state.sort,
      }).unwrap();
      dispatch(setOperatorData({ list: res }));
      setState(prev => ({ ...prev, isLoading: false }));
    } catch (e) {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleStateFilter = values => {
    if (values.length !== 0) {
      let filterQuery = '&filter=state in';
      values.map(v => {
        filterQuery += ` ${v}`;
        return filterQuery;
      });
      setState(prev => ({ ...prev, stateFilter: filterQuery }));
    } else {
      setState(prev => ({ ...prev, stateFilter: '' }));
    }
  };

  const handleSort = value => {
    setState(prev => ({ ...prev, sort: value }));
  };

  const handleSearch = e => {
    setState(prev => ({ ...prev, searchText: e.target.value }));
  };

  const handleKeyDownSearch = async e => {
    let searchFilterQuery = '';
    if (e.keyCode === 13) {
      const { offset, limit, filterQuery, sort, searchText } = state;
      if (searchText) {
        if (!isNaN(searchText, 10) && searchText < 100000000) {
          searchFilterQuery += `&filter=or.id eq ${searchText}`;
        }
        searchFilterQuery += `&filter=or.fullName iLike %25${searchText}%25&filter=or.eid iLike %25${searchText}%25&filter=or.email iLike %25${searchText}%25`;
      } else {
        searchFilterQuery = '';
      }
      setState(prev => ({ ...prev, searchFilterQuery: searchFilterQuery, isLoading: true }));
      try {
        const res = await getOperatorList({
          offset: 0,
          limit: 10,
          or: false,
          filter: filterQuery + searchFilterQuery,
          sort: sort,
        }).unwrap();
        dispatch(setOperatorData({ list: res }));
        setState(prev => ({ ...prev, isLoading: false }));
      } catch (e) {
        setState(prev => ({ ...prev, isLoading: false }));
      }
    }
  };

  const handleApplyFilter = async () => {
    const { stateFilter, sort, searchFilterQuery } = state;
    setState(prev => ({ ...prev, filterQuery: stateFilter, isLoading: true }));
    try {
      const res = await getOperatorList({
        offset: 0,
        limit: 10,
        or: false,
        filter: stateFilter + searchFilterQuery,
        sort: sort,
      }).unwrap();
      dispatch(setOperatorData({ list: res }));
      setState(prev => ({ ...prev, isLoading: false }));
    } catch (e) {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  return (
    <div className="operator_list_layout">
      <Loading visible={state.isLoading} />
      <ContentHeader type="operator_list" />
      <div className="operator_filter_wrapper">
        <OperatorFilter
          searchText={state.searchText}
          onStateFilter={handleStateFilter}
          onSort={handleSort}
          onSearch={handleSearch}
          onKeyDownSearch={handleKeyDownSearch}
          onApplyFilter={handleApplyFilter}
        />
        <OperatorTable operatorData={list.rows || []} onChangePage={handleChangePage} total={list.totalCount} />
      </div>
    </div>
  );
};

export default OperatorAgentList;
